export default __webpack_public_path__ + "static/media/usdc.196a0ebf.svg";